<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+query.comtype === 2 || +loginUser.comtype === 1">
          <div class="label">经办人</div>
          <div class="field">
            <el-input v-model.trim="query.pUsername" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true" :defaultPage="10"
            :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  export default {
    name: 'projectReviewIndex',
    data () {
      return {
        loginUser: this.$store.getters.loginUser,
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        pUsernameDisabled: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false, width: 150},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectdesc', fieldtype: 'C', title: '项目内容',calculExpr:'',addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          { field: 'projectlimitamtdesc',width:100, fieldtype: 'C', title: '项目预算',calculExpr:'',addNewRowFlg: false},
          { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'dailiname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          { field: 'projectdoneflgdesc', fieldtype: 'C', title: '评审方法',calculExpr:'',addNewRowFlg: false, width: 120},
          { field: 'projectstatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'projectrecusername', fieldtype: 'C', title: '建项人',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'projecttime', fieldtype: 'T', title: '建项时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', ''], width: 150},
          { title: '操作 ', width: 100, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                // if(+row.projectisqcheck !== 1 || (+row.projectqcheckflg === 1) || +row.projectdoneflg === 3){
                //   return [<vxe-button type='primary' onClick={this.goReview.bind(this, row)}>查看</vxe-button>]
                // } else {
                //   return [<vxe-button type='primary' onClick={this.goReview.bind(this, row)}>评审</vxe-button>]
                // }
                // if(+row.projectstatus>=30 || (+row.projectqcheckflg === 1) || +row.projectdoneflg === 3){
                if(+row.projectstatus>=30 || +row.projectdoneflg === 3){
                  return [<vxe-button type='primary' onClick={this.goReview.bind(this, row)}>查看</vxe-button>]
                } else if (+row.projectisqcheck === 1 && +row.projectqcheckflg === 0) {
                  return [<vxe-button type='primary' onClick={this.goReview.bind(this, row)}>评审</vxe-button>]
                } else {  
                  //20210226 提交名词修改为评审
                  return [<vxe-button type='primary' onClick={this.goReview.bind(this, row)}>评审</vxe-button>]
                }
              }
            }
          }
        ],
        project: {},
        projectStatusList: [],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          comtype: this.$store.getters.loginUser.comtype,
          total: 0,
          limit: 10,
          offset: 0
        }
      }
    },
    created () {
      if (+this.$store.getters.loginUser.comtype === 2 || this.$store.getters.loginUser.comtype === 1) {
        if (+this.$store.getters.loginUser.comtype === 2 && +this.$store.getters.loginUser.roletype === 2) {
          this.query.pUsername = this.$store.getters.loginUser.username
          this.pUsernameDisabled = true
        }
        this.cols.splice(4, 0, {
          field: "pusername",
          fieldtype: "C",
          title: "经办人",
          calculExpr: "",
          addNewRowFlg: false,
          width: 80,
        })
      }
    },
    activated() {
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async goReview (row) {
        console.log('-------row---------',row.projectid,row.projectname);
        this.$router.push({name: 'projectReviewGcTab', params: {projectid: row.projectid}})
      },
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.list = []
        this.btnLoading = false
        this.project = {}
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'projectReviewGcTab', params: {projectid: this.project.projectid}})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.fromcode = 'xmps'
        this.query.areaid = 0
        this.query.selectField = `projectcode,projectlimitamt,projectptccode,projectname,projecttime,projectid,projectstatus`
        let res = {}
        if (this.query.comtype === 2) {
           res = await request({
            method: "get",
            url: "/xmgl/project/getPurchaserPageList",
            params: this.query,
          });
        } else {
          res = await request({
            method: 'get',
            url: '/xmgl/project/getPageList',
            params: this.query
          })
        }
        
        res.list.forEach(e=>{
          // if(e.projectjkactualendtime && +e.projectstatus < 30){
          //   e.projectstatusname = '待提交'
          // }
          if(+e.projectstatus>=30 || +e.projectdoneflg === 3){
            e.projectstatusname = '查看'
          } else if (+e.projectisqcheck === 1 && +e.projectqcheckflg === 0) {
            e.projectstatusname = '待评审'
          } else {
            e.projectstatusname = '待提交'
          }
        })
        
        this.list = res.list
        res.list.forEach(e => {
          e.projectisinviteCN = +e.projectisinvite === 1 ? '邀请':'公开'
          e.projectlimitamtdesc =  e.projectlimitamt?utils.comdify(e.projectlimitamt):e.projectlimitamt
        });
        this.query.total = res.count[0].count
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
</style>
